import { createSlice } from '@reduxjs/toolkit'
import { getRecords } from '../../lib/pouchDb'
import { onError } from '../../lib/sentry'

const initialState = {
  passwords: [],
  deletedPasswords: [],
  activePasswords: [],
  isLoading: false,
  error: null
}

const passwords = createSlice({
  name: 'passwords',
  initialState,
  reducers: {
    getPasswordsStart(state) {
      state.isLoading = true
      state.error = null
    },
    getPasswordsSuccess(state, action) {
      const { passwords } = action.payload
      state.passwords = passwords
      state.deletedPasswords = passwords.filter(item => item.deleted)
      state.activePasswords = passwords.filter(item => !item.deleted)
      state.isLoading = false
      state.error = null
    },
    getPasswordsFailure(state, action) {
      state.isLoading = false
      state.error = action.payload
    }
  }
})

export const {
  getPasswordsStart,
  getPasswordsSuccess,
  getPasswordsFailure
} = passwords.actions

export default passwords.reducer

export const fetchPasswords = (userId, masterKey) => async dispatch => {
  try {
    dispatch(getPasswordsStart())
    const passwords = await getRecords(userId, 'passwords', masterKey)
    dispatch(getPasswordsSuccess({ passwords }))
  } catch (err) {
    onError(err)
    dispatch(getPasswordsFailure(err.toString()))
  }
}
